import { clearModal } from '@hixme/modal'
import { connect } from 'react-redux'
import { getWaiter } from 'redux-waiter'

// route modules
import { handleActivityLogPopup } from 'helpers/activityLogHelper'
import withFeatureFlags from 'hocs/withFeatureFlags'
import { logGenericActivity } from 'modules/activity-log/log-generic-activity'
import { ShopForHealthAction } from 'routes/Benefits/HealthBundles/shop-for-health-activity-log/shop-for-health-log'
import { getPersonsSelector } from 'store/modules/persons/selectors'
import { isImpersonating } from 'store/modules/user-session/selectors'
import { VisionCoverageModal } from '../components'
import { actions, constants, selectors } from '../modules/vision-coverage'

const mapStateToProps = (state, props) => {
  const persons = selectors.getAllPersons(state)
  const fields = persons.map((p) => p.Id)
  const { Person: person } = getPersonsSelector(state)

  const initialValues = {}
  selectors.getSelectedPersons(state).forEach((person) => {
    initialValues[person.Id] = true
  })

  return {
    isProcessing: getWaiter(state, constants.GET_DENTAL_PLANS).isPending,
    persons,
    fields,
    initialValues,
    isImpersonated: isImpersonating(state),
    isTestUser: person?.IsTestUser,
    isActivityLogEnabled: props?.flags['enrollme.activity-log-reason-popup-enabled'],
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  onCancelClick: () => {
    dispatch(clearModal())
  },
  onSubmit: (values, _, submitProps) => {
    const onSubmitData = ({ reason, reasonCategory, zendeskTicket }) => {
      const activityLogOptions = {
        reason,
        reasonCategory,
        zendeskTicket,
      }

      return new Promise((resolve, reject) => {
        const selectedIds = Object.keys(values).reduce((prev, curr) => {
          if (values[curr]) prev.push(curr)
          return prev
        }, [])
        dispatch(actions.setSelectedPersons(selectedIds))
        dispatch(actions.updateVisionPlansWithCart()).then(
          () => {
            logGenericActivity({
              additionalData: {
                coveredPersons: selectedIds,
                values,
                ...activityLogOptions,
              },
              activity: 'edited vision coverage persons',
              action: ShopForHealthAction.EditVisionCoveragePersons,
            })
            dispatch(clearModal())
            resolve()
          },
          () => {
            reject()
          }
        )
      })
    }

    handleActivityLogPopup({
      isImpersonated: submitProps.isImpersonated,
      isTestUser: submitProps.isTestUser,
      isActivityLogEnabled: submitProps.isActivityLogEnabled,
      dispatch,
      contentText: 'Are you sure you want to edit vision coverage persons?',
      onSubmit: onSubmitData,
    })
  },
})

export default withFeatureFlags(connect(mapStateToProps, mapDispatchToProps)(VisionCoverageModal))
